import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';
import { race } from 'rxjs/operators';


@Component({
  selector: 'app-jockey-gear-checks',
  templateUrl: './jockey-gear-checks.component.html',
  styleUrls: ['./jockey-gear-checks.component.scss']
})

export class JockeyGearChecksComponent implements OnInit {

  @Input() jockey;
  @Input() race;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  manualEditing = false;
  disableReadScale = false;
  userId: number;
  headGears: any[];
  tongueStrapIndex: number;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    };
    this.headGears = this.jockey.headGears.filter(hg => hg.code !== 'T').slice(0);
    this.tongueStrapIndex = this.jockey.headGears.findIndex(hg => hg.code === 'T');

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  confirm() {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      updatedBy: this.userId,
      headGears: this.headGears.slice(0)
    };
    if (this.tongueStrapIndex !== -1) {
      payload.headGears.push(this.jockey.headGears[this.tongueStrapIndex]);
    }
    console.log(`[ DEBUG ] Sending payload`, payload);
    this.apiService.updateGearChecks(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.jockey.jockeyName} gear checks has been saved.`, 'Gear Checks');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the gear checks. Check your connection and Try again.`, 'Gear Checks');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
